import { render } from "./EditSpentPage.vue?vue&type=template&id=6ca64148&ts=true"
import script from "./EditSpentPage.vue?vue&type=script&lang=ts"
export * from "./EditSpentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__